export default __webpack_public_path__ + "hack-site/src/assets/imgs/subscription/credit-cards/mastercard.png";